var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "fieldset",
        {
          staticClass: "my-0 py-0 pb-0",
          class: `${
            _vm.$screen.width <= 576
              ? "card-inside bg-color-white border-ligth-starlight"
              : ""
          }`,
        },
        [
          _vm.$screen.width <= 576
            ? _c(
                "legend",
                {
                  staticClass: "text-color-rhapsody-in-blue-2",
                  class: `${_vm.$screen.width <= 576 ? "card-inside" : ""}`,
                },
                [
                  _vm._v(
                    "\n\t\t\t" + _vm._s(_vm.FormMSG(697, "Water")) + "\n\t\t"
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            { class: { "pt-1 pb-1": _vm.$screen.width <= 576 } },
            [
              _c(
                "b-row",
                [
                  _vm.$screen.width > 576
                    ? _c(
                        "b-col",
                        { attrs: { sm: "12", md: "2", lg: "2", xl: "2" } },
                        [
                          _c("b-form-input", {
                            staticClass: "bg-color-grams-hair",
                            attrs: {
                              value: _vm.FormMSG(697, "Water"),
                              disabled: "",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "4", lg: "4", xl: "4" } },
                    [
                      _c("supplier-energy-consumption", {
                        attrs: {
                          label: _vm.FormMSG(633, "Supplier"),
                          "dialog-title": _vm.FormMSG(253, "Water supplier"),
                          "hide-label": _vm.$screen.width > 576,
                          "supplier-type": "water",
                          "label-add-supplier": _vm.FormMSG(
                            198,
                            "New water supplier"
                          ),
                          "supplier-id": _vm.payload.waterSupplier,
                          disabled: _vm.disabled,
                        },
                        on: {
                          "supplier-energy:change":
                            _vm.handleSupplierSelectorChange,
                          "supplier-energy:unselect":
                            _vm.handleSupplierUnselect,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "2", lg: "2", xl: "2" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$screen.width <= 576
                                ? _vm.FormMSG(58, "Meter start")
                                : "",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                staticClass: "br-none",
                                class: { "bg-color-grams-hair": _vm.disabled },
                                attrs: { disabled: _vm.disabled },
                                on: { input: _vm.computeWaterConsumption },
                                model: {
                                  value: _vm.payload.waterMeterStart,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.payload,
                                      "waterMeterStart",
                                      $$v
                                    )
                                  },
                                  expression: "payload.waterMeterStart",
                                },
                              }),
                              _c(
                                "b-input-group-append",
                                [
                                  _c(
                                    "b-input-group-text",
                                    {
                                      staticClass:
                                        "bg-color-white input-group-text-bg-white",
                                    },
                                    [
                                      _c("div", { staticClass: "d-flex" }, [
                                        _vm.has(
                                          _vm.payload.waterMeterStartPict
                                        ) &&
                                        _vm.payload.waterMeterStartPict !== ""
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn-transparent text-color-blue-rinse",
                                                attrs: {
                                                  disabled: _vm.disabled,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showPicture([
                                                      _vm.payload
                                                        .waterMeterStartPict,
                                                    ])
                                                  },
                                                },
                                              },
                                              [
                                                _c(_vm.getLucideIcon("Image"), {
                                                  tag: "component",
                                                  attrs: { size: 20 },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        !_vm.$isPwa()
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn-transparent text-color-rhapsody-in-blue",
                                                attrs: {
                                                  disabled: _vm.disabled,
                                                },
                                                on: {
                                                  click:
                                                    _vm.openWaterPicModalStart,
                                                },
                                              },
                                              [
                                                _c(
                                                  _vm.getLucideIcon(
                                                    "Paperclip"
                                                  ),
                                                  {
                                                    tag: "component",
                                                    attrs: { size: 20 },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.$isPwa()
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn-transparent text-color-rhapsody-in-blue",
                                                attrs: {
                                                  disabled: _vm.disabled,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.startMobilePwaCapture(
                                                      "handleWaterPicStart"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  _vm.getLucideIcon(
                                                    "Paperclip"
                                                  ),
                                                  {
                                                    tag: "component",
                                                    attrs: { size: 20 },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "2", lg: "2", xl: "2" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label:
                              _vm.$screen.width <= 576
                                ? _vm.FormMSG(59, "Meter end")
                                : "",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                staticClass: "br-none",
                                class: { "bg-color-grams-hair": _vm.disabled },
                                attrs: { disabled: _vm.disabled },
                                on: { input: _vm.computeWaterConsumption },
                                model: {
                                  value: _vm.payload.waterMeterEnd,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.payload, "waterMeterEnd", $$v)
                                  },
                                  expression: "payload.waterMeterEnd",
                                },
                              }),
                              _c(
                                "b-input-group-append",
                                [
                                  _c(
                                    "b-input-group-text",
                                    {
                                      staticClass:
                                        "bg-color-white input-group-text-bg-white",
                                    },
                                    [
                                      _c("div", { staticClass: "d-flex" }, [
                                        _vm.has(
                                          _vm.payload.waterMeterEndPict
                                        ) &&
                                        _vm.payload.waterMeterEndPict !== ""
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn-transparent text-color-blue-rinse",
                                                attrs: {
                                                  disabled: _vm.disabled,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showPicture([
                                                      _vm.payload
                                                        .waterMeterEndPict,
                                                    ])
                                                  },
                                                },
                                              },
                                              [
                                                _c(_vm.getLucideIcon("Image"), {
                                                  tag: "component",
                                                  attrs: { size: 20 },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        !_vm.$isPwa()
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn-transparent text-color-rhapsody-in-blue",
                                                attrs: {
                                                  disabled: _vm.disabled,
                                                },
                                                on: {
                                                  click:
                                                    _vm.openWaterPicModalEnd,
                                                },
                                              },
                                              [
                                                _c(
                                                  _vm.getLucideIcon(
                                                    "Paperclip"
                                                  ),
                                                  {
                                                    tag: "component",
                                                    attrs: { size: 20 },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.$isPwa()
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn-transparent text-color-rhapsody-in-blue",
                                                attrs: {
                                                  disabled: _vm.disabled,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.startMobilePwaCapture(
                                                      "handleWaterPicEnd"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  _vm.getLucideIcon(
                                                    "Paperclip"
                                                  ),
                                                  {
                                                    tag: "component",
                                                    attrs: { size: 20 },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.isInvalid
                        ? _c("small", { staticStyle: { color: "red" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.FormMSG(
                                  1101,
                                  "Meter end must be greater than meter start"
                                )
                              ) + " "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "2", lg: "2", xl: "2" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                class: { "bg-color-grams-hair": _vm.disabled },
                                attrs: { disabled: _vm.disabled },
                                on: { input: _vm.computeWaterEnd },
                                model: {
                                  value: _vm.payload.consumptionWater,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.payload,
                                      "consumptionWater",
                                      $$v
                                    )
                                  },
                                  expression: "payload.consumptionWater",
                                },
                              }),
                              _c(
                                "b-input-group-append",
                                [
                                  _c(
                                    "b-input-group-text",
                                    {
                                      staticClass:
                                        "bg-color-north-wind text-color-white",
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.FormMSG(260, "m3")) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("Capture", {
        attrs: {
          "custom-ref": _vm.rendRef("pic_elec_system_start"),
          "auto-crop-capture": "",
          "only-one-crop-mode": "",
          "parent-id": _vm.parentId,
          "parent-type": "location",
          "parent-sub-type": "location_water_start",
        },
        on: { change: _vm.handleWaterPicStart },
        model: {
          value: _vm.isWaterPicStartModalOpen,
          callback: function ($$v) {
            _vm.isWaterPicStartModalOpen = $$v
          },
          expression: "isWaterPicStartModalOpen",
        },
      }),
      _c("Capture", {
        attrs: {
          "custom-ref": _vm.rendRef("pic_elec_system_end"),
          "auto-crop-capture": "",
          "only-one-crop-mode": "",
          "parent-id": _vm.parentId,
          "parent-type": "location",
          "parent-sub-type": "location_water_end",
        },
        on: { change: _vm.handleWaterPicEnd },
        model: {
          value: _vm.isWaterPicEndModalOpen,
          callback: function ($$v) {
            _vm.isWaterPicEndModalOpen = $$v
          },
          expression: "isWaterPicEndModalOpen",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }